import { render, staticRenderFns } from "./BadgePoly.vue?vue&type=template&id=907b38fe&scoped=true&"
import script from "./BadgePoly.vue?vue&type=script&lang=js&"
export * from "./BadgePoly.vue?vue&type=script&lang=js&"
import style0 from "./BadgePoly.vue?vue&type=style&index=0&id=907b38fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907b38fe",
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip});
